module.exports = __webpack_public_path__ + "static/media/07_humidity_fair.2b96bbfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/intro-3/07_humidity_fair.png
// module id = 704
// module chunks = 0